import { queryOptions } from "@tanstack/react-query"
import { configurationService } from "@/services/configuration.service"
import { themeService } from "@/services/theme.service"

export const configQueryOptions = {
  all: queryOptions({
    queryKey: ["configurations"],
    queryFn: async () => {
      const response = await configurationService.fetchConfigurations()
      return response
    },
  }),
  directory: queryOptions({
    queryKey: ["configurations", "directory"],
    queryFn: async () => {
      const response = await configurationService.getDisciplineLogoDirectory()
      return response
    },
  }),
}

export const themeQueryOptions = {
  all: queryOptions({
    queryKey: ["theme"],
    queryFn: async () => {
      const response = await themeService.fetchThemes()
      return response
    },
  }),
}
